import { __, sprintf } from "@wordpress/i18n";
import { date } from "@wordpress/date";
import { useState, useEffect, useCallback } from "react";
import { BigLoader, getNonce, DeleteIcon,BulkDeleteIcon } from "./icons";

const Subscribers = () => {
	const [loading, setLoading] = useState(true);
	const [notification, setNotification] = useState({
		status: "error",
		message: "",
	});
	const [selected, setSelected] = useState([]);
	const [deletePop, setDeletePop] = useState(false);
	const [subscriptionData, setSubscriptionData] = useState({
		count: 0,
		totalcount: 0,
		data: [],
	});

	const [loadParams, setLoadParams] = useState({ page: 1, s: "", tag: "" });
	const [tags, setTags] = useState([]);
	
	const headerDiscription = sprintf(
		__("Showing ( %1s / %2s ) leads", "easy-email-integration"),
		subscriptionData.count,
		subscriptionData.totalcount
	);

	const [displays, setDisplays] = useState([
		{
			value: "date_time",
			label: __("Date", "easy-email-integration"),
			display: true,
		},
		{
			value: "form_name",
			label: __("Form Name", "easy-email-integration"),
			display: true,
		},
		{
			value: "name",
			label: __("Name", "easy-email-integration"),
			display: true,
		},
		{
			value: "email",
			label: __("Email", "easy-email-integration"),
			display: true,
		},
		{ value: "tag", label: __("Tag", "easy-email-integration"), display: true },
		{
			value: "location",
			label: __("Location", "easy-email-integration"),
			display: true,
		},
	]);
	const [tagSelectorOpen, setTagSelectorOpen] = useState(false);
	const [displaySelectorOpen, setDisplaySelectorOpen] = useState(false);

	useEffect(() => {
		loadSubscriptionTags();
		loadSubScriptionData(loadParams);
	}, []);

	useEffect(() => {
		loadSubScriptionData(loadParams);
	}, [loadParams]);

	const notificationAutoClose = () => {
		setTimeout(() => {
			setNotification({ ...notification, message: "" });
		}, 5000);
	};

	useEffect(() => {
		if (notification) {
			notificationAutoClose();
		}
	}, [notification]);

	const subscribeSelectionHandler = (e) => {
		let currentValue = e.target.value;
		if (currentValue === "all_items") {
			if (selected.includes("all_items")) {
				setSelected([]);
			} else {
				let items = ["all_items"];
				subscriptionData.data.map((item) => {
					items = [...items, item.id];
				});
				setSelected(items);
			}
		} else {
			setSelected((preval) => {
				let prev = preval;
				if (prev.includes("all_items")) {
					prev.splice(prev.indexOf("all_items"), 1);
				}
				if (prev.includes(currentValue)) {
					prev = prev.filter((item) => item !== currentValue);
				} else {
					prev = [...prev, currentValue];
				}
				return prev;
			});
		}
	};

	
	if (subscriptionData.data.length === 0 && loadParams.page > 1) {
		setLoadParams(prev=>({...prev, page: loadParams.page - 1}));
	}

	const loadSubScriptionData = async (obj) => {
		setLoading(true);
		let params = new URLSearchParams(obj).toString();
		const response = await fetch(`${easy_email_integration.ajaxurl}/eei/v1/subscribers?${params}`);
		if (response.status !== "error") {
			const data = await response.json();
			setSubscriptionData(data);
			if (subscriptionData.data.length === 0 && loadParams.page > 1) {
				setLoadParams(prev=>({...prev, page: loadParams.page - 1}));
			}
		} else {
			setNotification({
				status: "success",
				message: __(
					"Sorry, there was some error loading data",
					"easy-email-integration"
				),
			});
		}
		setLoading(false);
	};

	const loadSubscriptionTags = async () => {
		const response = await fetch(`${easy_email_integration.ajaxurl}/eei/v1/tags`);
		if (response.status !== "error") {
			const data = await response.json();
			setTags(data);
		} else {
			console.log("Sorry, there was some error loading tags");
		}
	};

	const loadParamHandler = (e) => {
		e.preventDefault();
		if (e.target.name !== "page") {
			setLoadParams({
				...loadParams,
				[e.target.name]: e.target.value,
				page: 1,
			});
		} else {
			setLoadParams({ ...loadParams, [e.target.name]: e.target.value });
		}
	};

	const tagSelectorHandler = (e) => {
		let currentValue = e.target.value;
		if (currentValue !== "") {
			let prevValues = Boolean(loadParams.tag) ? loadParams.tag.split(",") : [];
			if (prevValues.includes(currentValue)) {
				prevValues.splice(prevValues.indexOf(currentValue), 1);
			} else {
				prevValues.push(currentValue);
			}
			setLoadParams({ ...loadParams, tag: prevValues.join(",") });
		} else {
			setLoadParams({ ...loadParams, tag: "" });
		}
		//setTagSelectorOpen(false);
	};

	const displaySelectorHandler = useCallback(
		(e) => {
			let currentValue = e.target.value;

			setDisplays((prev) =>
				prev.map((dis) => {
					if (dis.value === currentValue) {
						return { ...dis, display: !dis.display };
					} else {
						return dis;
					}
				})
			);
			//setDisplaySelectorOpen(false);
		},
		[displays]
	);

	const deleteInBulk = () => {
		let ids = selected;
		if (ids.includes("all_items")) {
			ids.splice(ids.indexOf("all_items"), 1);
		}
		deleteHandler(ids);
		setSelected([]);
	};

	const deleteHandler = (ids) => {
		ids.map(async (id) => {
			const rawResponse = await fetch(`${easy_email_integration.ajaxurl}/eei/v1/delete/${id}`, {
				method: "DELETE",
			});

			const response = await rawResponse.json();
			if (response.success) {
				loadSubScriptionData(loadParams);
				setNotification({
					status: "success",
					message: __(
						"Successfully deleted subscription",
						"easy-email-integration"
					),
				});
			} else {
				setNotification({
					status: "error",
					message: __(
						"There was a problem deleting. Try again.",
						"easy-email-integration"
					),
				});
			}
		});
	};

	const closeAllSelector = (e) => {
		if (
			!e.target.classList.contains("tag-selector-toggle") &&
			!e.target.classList.contains("tag_input_label") &&
			!e.target.classList.contains("tag_input_input")
		) {
			setTagSelectorOpen(false);
		}
		if (
			!e.target.classList.contains("display-selector-toggle") &&
			!e.target.classList.contains("display_input_label") &&
			!e.target.classList.contains("display_input_input")
		) {
			setDisplaySelectorOpen(false);
		}
	};

	return (
		<div onClick={closeAllSelector}>
			<h2 className="title">{__("Leads", "easy-email-integration")}</h2>
			<p
				className="description"
				dangerouslySetInnerHTML={{ __html: headerDiscription }}
			></p>
			<div className="easy_email_integration-subscriber-table-actions">
			{tags.length > 0 && (
				<div className="eei-filter easy-email-integration-search">
					<span className="dashicons dashicons-search"></span>
					<input
						type="search"
						name="s"
						placeholder="Search"
						value={loadParams.s}
						onChange={loadParamHandler}
					/>
				</div>
			)}
				{tags.length > 0 && (
					<div className="eei-filter easy-email-integration-tag">
						<span className="dashicons dashicons-tag"></span>
						<span
							className="inputPlaceholder inputPlaceholderDrop tag-selector-toggle"
							onClick={() => setTagSelectorOpen((prev) => !prev)}
						>
							{loadParams.tag
								? loadParams.tag
								: __("All Tags", "easy-email-integration")}
						</span>
						{tagSelectorOpen && (
							<div className="check-selection">
								<span className="selector-label">
									{__("Tag Name", "easy-email-integration")}
								</span>
								<div className="check-selector">
									<label className="tag_input_label">
										<input
											type="checkbox"
											name="tag"
											value=""
											className="tag_input_input"
											checked={Boolean(!loadParams.tag)}
											onChange={tagSelectorHandler}
										/>
										{__("All Tags", "easy-email-integration")}
									</label>
									{tags.map((tag) => (
										<React.Fragment>
											{tag && (
												<label className="tag_input_label">
													{Boolean(!loadParams.tag) ? (
														<input
															type="checkbox"
															name="tag"
															className="tag_input_input"
															value={tag}
															checked={true}
															onChange={tagSelectorHandler}
														/>
													) : (
														<input
															type="checkbox"
															name="tag"
															value={tag}
															checked={loadParams.tag.split(",").includes(tag)}
															onChange={tagSelectorHandler}
														/>
													)}
													{tag}
												</label>
											)}
										</React.Fragment>
									))}
								</div>
							</div>
						)}
					</div>
				)}
				{tags.length > 0 && (
				<div className="eei-filter easy-email-integration-display">
					<span className="dashicons dashicons-screenoptions"></span>
					<span
						className="inputPlaceholder inputPlaceholderDrop inputPlaceholderIcon display-selector-toggle"
						onClick={() => setDisplaySelectorOpen((prev) => !prev)}
					></span>
					{displaySelectorOpen && (
						<div className="check-selection">
							<span className="selector-label">
								{__("Displayed Column", "easy-email-integration")}
							</span>
							<div className="check-selector">
								{displays.map((display) => (
									<label key={display.value} className="display_input_label">
										<input
											className="display_input_input"
											type="checkbox"
											name="display"
											value={display.value}
											checked={display.display}
											onChange={displaySelectorHandler}
										/>
										{display.label}
									</label>
								))}
							</div>
						</div>
					)}
				</div>
				)}
				{subscriptionData.count > 0 && (
					<React.Fragment>
						<div
							className={`eei-filter easy-email-integration-delete ${selected.length ? "inactive" : "disabled"
								}`}
						>
							{/* <BulkDeleteIcon/> */}
							<span className="dashicons dashicons-trash bulkdelete"></span>
							<span
								className={`inputPlaceholder inputPlaceholderDrop inputPlaceholderIcon ${selected.length ? "active" : "inactive"}`}
								onClick={() => {
									setDeletePop(true);
									//deleteInBulk();
								}}
							>
							</span>
						</div>
						<form
							className="eei-filter easy-email-integration-export"
							action={`${eei.site_url}/wp-admin/admin.php?page=easy-email-integration-subscription`}
							method="post"
						>
							<span className="dashicons dashicons-database-export"></span>
							<input
								type="hidden"
								name="col"
								value={displays
									.filter((d) => d.display)
									.map((d) => {
										return d.value === "location" ? "city, country" : d.value;
									})
									.join(",")}
							/>
							<input type="hidden" name="nonce" value={getNonce()} />
							<button
								className="inputPlaceholder inputPlaceholderDrop inputPlaceholderIcon"
								type="submit"
								name="download_csv"
							>
								&nbsp;
							</button>
						</form>
					</React.Fragment>
				)}
			</div>
			<div className="easy_email_integration-subscriber-table">
				{loading ? (
					<div className="eei-loader">
						<BigLoader />
					</div>
				) : (
					<div id="subscriber_list_actions">
						{subscriptionData.count > 0 ? (
							<div>
								<table>
									<thead>
										<tr>
											<th>
												<input
													type="checkbox"
													name="checked_subscribers"
													value="all_items"
													checked={selected.includes("all_items")}
													onChange={subscribeSelectionHandler}
												/>
											</th>
											{displays.map(
												(column) => column.display && <th>{column.label}</th>
											)}
											<th></th>
										</tr>
									</thead>
									<tbody>
										{subscriptionData.data.map((item) => (
											<tr key={item.id}>
												<td>
													<input
														type="checkbox"
														name="checked_subscribers"
														value={item.id}
														checked={selected.includes(item.id)}
														onChange={subscribeSelectionHandler}
													/>
												</td>
												{displays.find((column) => column.value === "date_time")
													.display && (
														<td>
															<span className="date">
																{date(eei.date_format, item.date_time)}
															</span>
															<span className="time">
																{date(eei.time_format, item.date_time)}
															</span>
														</td>
													)}
												{displays.find((column) => column.value === "form_name").display && <td>{item.form_name}</td>}
												{displays.find((column) => column.value === "name").display && <td>{item.name}</td>}
												{displays.find((column) => column.value === "email").display && <td>{item.email}</td>}
												{displays.find((column) => column.value === "tag").display && <td>{item.tag}</td>}
												{displays.find((column) => column.value === "location").display && (
														<td>
															<span className="city">{item.city}</span>
															<span className="country">{item.country}</span>
														</td>
													)}
												<td>
													<button
														type="button"
														className="easy_email_integration_delete_entry"
														onClick={() => {
															setSelected([item.id]);
															setDeletePop(true);
															//deleteHandler([item.id])
														}}
													>
														{/* <DeleteIcon /> */}
														<span className="dashicons dashicons-trash"></span>
													</button>
												</td>
											</tr>
										))}
									</tbody>
								</table>

								{/* Pagination */}
								{(() => {
									
									if (subscriptionData.currentcount > 10) {
										let pages = [];
										let uptoPage =
											subscriptionData.currentcount % 10 === 0 ? parseInt(subscriptionData.currentcount / 10)
												: parseInt(subscriptionData.currentcount / 10) + 1;

										if (parseInt(loadParams.page) > 1) {
											pages.push(
												<button
													type="button"
													className="page-numbers page-prev"
													name="page"
													value={parseInt(loadParams.page) - 1}
													onClick={loadParamHandler}
												>
													<span className="dashicons dashicons-arrow-left-alt2"></span>
												</button>
											);
										}

										for (var i = 1; i <= uptoPage; i++) {
											pages.push(
												<button
													type="button"
													className={`page-numbers ${i === parseInt(loadParams.page) ? "current" : ""
														}`}
													name="page"
													value={i}
													onClick={loadParamHandler}
												>
													{i}
												</button>
											);
										}

										if (parseInt(loadParams.page) < uptoPage) {
											pages.push(
												<button
													type="button"
													className="page-numbers page-next"
													name="page"
													value={parseInt(loadParams.page) + 1}
													onClick={loadParamHandler}
												>
													<span className="dashicons dashicons-arrow-right-alt2"></span>
												</button>
											);
										}

										return <div className="subscribe-pagination">{pages}</div>;
									}
								})()}
							</div>
						) : (
							<p>{__("No Subscriber Found", "easy-email-integration")}</p>
						)}
					</div>
				)}
			</div>

			{/* Delete Popup */}
			{selected.length > 0 && deletePop && (
				<div className="delete-popup" onClick={(e) => {
					if(e.target.classList.contains('delete-popup')){
						setDeletePop(false);
						setSelected([]);
					}
				}}>
					<div class="delete-popup-wrapper">
						<span class="dashicons dashicons-no-alt close-btn" onClick={() => {
							setDeletePop(false);
							setSelected([]);
						}}></span>
						<h3>{__('Are you sure to Delete?', 'easy-email-integration')}</h3>
						<p>{selected.length > 1 ? __('You are about to delete these leads permanently, Your will no longer to see these leads if you delete them.', 'easy-email-integration') : __('You are about to delete this lead permanently, Your will no longer to see this lead if you delete it.', 'easy-email-integration')}</p>
						<div class="eei-btn-group">
							<button type="button" class="actionBtn actionCancel" onClick={() => {
								setDeletePop(false);
								setSelected([]);
							}}>{__('Cancel', 'easy-email-integration')}</button>
							<button type="button" class="actionBtn actionDelete" onClick={deleteInBulk}>{__('Delete', 'easy-email-integration')}</button>
						</div>
					</div>
				</div>
			)}

			{/* Notification */}
			{notification.message && (
				<div className={`eei-notification ${notification.status}`}>
					<p>{notification.message}</p>
				</div>
			)}
		</div>
	);
};

export default Subscribers;